
  import Events from '@/events/Events';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    components: {
      DialogsBaseSection,
      CheckboxRichText: () => import('@/components/elements/CheckboxRichText'),
    },
    mixins: [ScreenSize],
    props: {
      activities: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data() {
      return {
        section: {},
        questionDialog: false,
        availableTopics: [
          this.$t('organization.question_topics_project_request_staff'),
          this.$t('organization.question_topics_project_request_conception'),
          this.$t('organization.question_topics_project_request_full_service'),
          this.$t('organization.question_topics_misc'),
        ],
        availableActivities: [],
        availablePersonnelRequirements: [
          {key: 'none', text: 'kein Personalbedarf', value: 'none'},
          {key: '1', text: '1 Person', value: 'personnel_requirement.pr_1'},
          {
            key: '2',
            text: '2 bis 5 Personen',
            value: 'personnel_requirement.pr_2',
          },
          {
            key: '6',
            text: '6 bis 9 Personen',
            value: 'personnel_requirement.pr_6',
          },
          {
            key: '10',
            text: '10 bis 19 Personen',
            value: 'personnel_requirement.pr_10',
          },
          {
            key: '20',
            text: '20 bis 49 Personen',
            value: 'personnel_requirement.pr_20',
          },
          {
            key: '50',
            text: '50 bis 99 Personen',
            value: 'personnel_requirement.pr_50',
          },
          {
            key: '100',
            text: '100 bis 199 Personen',
            value: 'personnel_requirement.pr_100',
          },
          {
            key: '200',
            text: '200 bis 299 Personen',
            value: 'personnel_requirement.pr_200',
          },
          {
            key: '300',
            text: '300 bis 399 Personen',
            value: 'personnel_requirement.pr_300',
          },
          {
            key: '400',
            text: '400 bis 499 Personen',
            value: 'personnel_requirement.pr_400',
          },
          {
            key: '500',
            text: 'mehr als 500 Personen',
            value: 'personnel_requirement.pr_500',
          },
          {key: 'unknown', text: 'unbekannt', value: 'none'},
        ],
        questionData: {
          name: '',
          company: '',
          email: '',
          phone: '',
          topic: '',
          description: '',
          checkbox: false,
          activities: [],
          personnelRequirement: '',
        },
      };
    },
    async fetch() {
      this.section = await this.$cachedStrapi
        .find('organization-question-dialog-in-listing')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
    },
    watch: {
      '$auth.loggedIn': function () {
        this.setValuesForLoggedUser();
      },
    },
    mounted() {
      this.activities.forEach((item) => {
        this.availableActivities.push({
          value: item.value,
          text: this.$t(item.value),
        });
      });
      this.setValuesForLoggedUser();
    },
    methods: {
      setValuesForLoggedUser() {
        if (this.$auth.loggedIn) {
          if (this.$auth.user.candidateProfile.fullName) {
            this.questionData.name = this.$auth.user.candidateProfile.fullName;
          }
          if (this.$auth.user.email) {
            this.questionData.email = this.$auth.user.email;
          }
          Object.keys(this.$auth.user.candidateProfile.communicationData).map(
            (key) => {
              if (
                this.$auth.user.candidateProfile.communicationData[key].type ===
                  'communication_data_type.mobile' ||
                this.$auth.user.candidateProfile.communicationData[key].type ===
                  'communication_data_type.tel'
              ) {
                this.questionData.phone =
                  this.$auth.user.candidateProfile.communicationData[key].value;
              }
            }
          );
        }
      },
      resetForm() {
        this.$refs.organizationQuestionFormInListing.resetValidation();
        this.$refs.organizationQuestionFormInListing.$children.forEach(
          (child) => {
            if (Object.prototype.hasOwnProperty.call(child, 'reset')) {
              child.reset();
            }
          }
        );
        this.questionData = {
          name: '',
          company: '',
          email: '',
          phone: '',
          topic: '',
          description: '',
          checkbox: false,
          activities: [],
          personnelRequirement: '',
        };
        this.setValuesForLoggedUser();
      },
      async sendQuestion() {
        await this.$store
          .dispatch('api/organization/contactAboutProject', {
            data: this.questionData,
          })
          .then(() => {
            this.$notifications.showNotification({
              message: this.$t('organization.question_success_in_listing'),
              color: 'success',
              timeout: 3000,
            });
            this.$emitWithClientData(
              Events.OrganizationProjectRequest,
              this.questionData
            );
            this.questionDialog = false;
            this.resetForm();
          })
          .catch((e) => {
            if (e.response.status !== 200) {
              this.$notifications.showNotification({
                message: this.$t('organization.question_error_listing'),
                color: 'error',
                timeout: 5000,
              });
            }
          });
      },
    },
  };
